import { postResetPassword } from '@/services/userSettings';
export async function resetUserPassword(userId) {
    const response = await postResetPassword(userId);
    return response.data;
}
